<template>
  <div id="MonitorChildrenTable" style="background-color: white;">
    <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;">
        <el-form-item label="商品标题" :label-width="formLabelWidth">
          <el-input
            clearable
            placeholder="请输入"
            v-model="list.itemtitle"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品" :label-width="formLabelWidth">
          <el-input
            clearable
            placeholder="请输入"
            v-model="list.productname"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <el-select v-model="list.status" filterable placeholder="请选择" size="small" multiple clearable>
            <el-option label="上架" value="2"></el-option>
            <el-option label="下架" value="3"></el-option>
            <el-option label="授权店铺" value="4"></el-option>
            <el-option label="灰名单" value="5"></el-option>
            <el-option label="黑名单" value="6"></el-option>
            <el-option label="标价低" value="8"></el-option>
            <el-option label="到手价低" value="9"></el-option>
            <el-option label="系统报备活动" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
        </el-form-item>
        <el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="search-btn" @click="getProductMonitorPage()">查询</el-button>
        </el-form-item>
      </el-form>
    </section>
    <div>
      <el-button size="small" style="margin: 0 0 8px 20px;" @click="skudownLoad" type="primary">下载数据</el-button>
      <div style="padding: 0 20px 8px 20px;">
        <el-table ref="multipleTable" :data="paramsValue" tooltip-effect="dark" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
          <el-table-column label="商品信息" prop="itemtitle" width="480">
            <template slot-scope="scope">
              <div class="shopMain">
                <img :src="scope.row.logopicurl_details?scope.row.logopicurl_details:scope.row.logopicurl" alt/>
                <div class="content">
                  <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
                    {{scope.row.itemtitle_details?scope.row.itemtitle_details:scope.row.itemtitle}}
                  </el-link>
                  <div class="align_left" v-show="scope.row.itemtype != 2">
                    {{scope.row.productname}}
                    <el-popover placement="top-start" width="200" trigger="hover" v-show="scope.row.productname">
                      <div>
                        <div v-for="item in  $options.filters.objToAr(scope.row.productPrice)" :key="item.name">
                          <div>{{item.name}}:{{item.val}}</div>
                        </div>
                      </div>
                      <i class="el-icon-warning-outline" slot="reference"></i>
                    </el-popover>
                  </div>
                  <el-button type="primary" size="mini" plain @click="skuListChildShow(scope.row.itemid,scope.row.platform)" v-show="scope.row.itemtype == 2">
                    SKU列表
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="价格" width="200">
            <template slot-scope="scope">
              <div style="float: left;width: 100%;">
                <div v-if="scope.row.price" style="float: left;">标价：¥ {{scope.row.price}}</div>
                <div v-if="scope.row.islowprice" class="islowpriceStyle" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              </div>

              <div style="float: left;;width: 100%;">
                <div v-if="scope.row.availableprice" style="float: left;">
                  到手价：¥ {{scope.row.availableprice}}
                </div>
                <div v-if="scope.row.availableislowprice" style="width: 51px;float: right;margin: 3px 10px;" class="availableislowpriceStyle">
                  到手低
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="限价" width="200">
            <template slot-scope="scope">
              <div style="float: left;width: 100%;">
                <div v-if="scope.row.checkprice" style="float: left;">标价限价：¥ {{scope.row.checkprice}}</div>
                <div v-if="scope.row.availablecheckprice" style="float: left;">到手价限价：¥ {{scope.row.availablecheckprice}}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="优惠说明" width="300">
            <template slot-scope="scope">
              <couponsStyle :couponsStyle="scope.row.couponsChildList" :couponsPlatform="scope.row.platform"/>
            </template>
          </el-table-column>

          <el-table-column label="店铺信息" show-overflow-tooltip width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
              <div v-else class="align_left ellipsis">/</div>
              <div
                v-show="scope.row.wangwang && scope.row.platform == 'TB' || scope.row.platform == '1688' || scope.row.platform == 'TM'"
                class="align_left ellipsis"
              >{{scope.row.wangwang}}</div>
              <div class="tall_icon">
                <img
                  :src='require("@/assets/img/platform/pla_"+scope.row.platform+".png")'
                  alt
                  class="edit_icon"
                />
                <span style="margin-top: 8px;" class="shoptype green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
                <ShopType style="margin-top: 8px;" :shoptype="scope.row.shoptype" v-if="scope.row.shoptype"/>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="状态" width="250">
            <template slot-scope="scope">
              <div v-show="scope.row.status=='上架'" class="have">上架</div>
              <div v-show="scope.row.status=='下架'" class="out">下架</div>
              <div v-show="scope.row.status=='已删除'" class="out">已删除</div>
              <div v-show="scope.row.status=='链接失效'" class="failure">链接失效</div>
              <div v-show="scope.row.camisreport == true" class="reportingActivities">系统报备活动</div>
              <div v-show="scope.row.ischange == '是'" slot="reference" style="cursor:pointer" class="haveImg" @click="changeClick(scope.row.itemid,scope.row.platform)">
                <img src="https://brm.olonger.com/ex-img/zhiwen-status.png"/>
              </div>
              <div v-show="scope.row.camisreport" class="haveImg">
                <img src="https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572505655208.png"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="监控快照" width="250">
            <template slot-scope="scope">
              <el-link :href="scope.row.monitorpic" target="_blank" type="primary" :underline="false" v-if="scope.row.monitorpic">违规截图</el-link>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-if="paramsValue&&paramsValue.length>0"
          :currentPage="currentPage"
          :pageSize="pageSize"
          :total="total"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></pagination>
      </div>
    </div>
  </div>

</template>

<script>
import pagination from "../../../../components/dataTable/pagination";
import aes from "@/libs/aes";
import ShopType from "@/components/shopType";
import couponsStyle from "@/components/couponsStyle";
import skuList from "../../BrandMerchandise/skuList"; //sku列表
  export default {
    name: 'MonitorChildrenTable',
    props: {
      paramsTime: {
        type: String,
      },
      paramsId: {
        type: String,
      },
    },
    data() {
      return {
        monitortime: "",
        paramsValue: [],
        formLabelWidth: "100px",
        pageNo: 1,
        pageSize: 10,
        currentPage: 10,
        total: 10,
        list: {
          platform: [],
          itemtitle: "",
          shopname: "", //店铺名称
          status: [], // 状态
          productname: "" // 产品信息
        },
      }
    },
    methods: {
      skudownLoad() {

      },
      pageData (data) {
        this.monitortime = data
        this.getProductMonitorPage()
      },
      handleSizeChange(val) {
        //每页
        this.pageSize = val;
        this.getProductMonitorPage();
      },
      handleCurrentChange(val) {
        //当前页
        this.pageNo = val;
        this.getProductMonitorPage();
      },
      getProductMonitorPage() {
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          planid: this.paramsId,
          monitortime: this.monitortime,
        }
        if (this.list.platform.length > 0) {
          params.platform = this.list.platform.join(',')
        }
        if (this.list.itemtitle) {
          params.itemtitle = this.list.itemtitle
        }
        if (this.list.shopname) {
          params.shopname = this.list.shopname
        }
        if (this.list.status.length > 0) {
          params.status = this.list.status.join(',')
        }
        if (this.list.productname) {
          params.productname = this.list.productname
        }
        fetch({
          url: "hcm/hcmShopMonitor/getShopMonitorDetailPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.paramsValue = []
            this.paramsValue = data.content
            this.total = data.totalElements
          }
        }).catch(err => {

        })
      }
    },
    filters: {
      newArrayq: function(value) {
        if (value) {
          var ss = [];
          if (value) {
            var s = value;
            ss = s.split(",");
          }
          return ss;
        }
      },
      bjBigSmall: aes.bjBigSmall,
      objToAr: aes.objToArr
    },
    components: {
      pagination,
      skuList,
  		ShopType,
      couponsStyle
    }
  }
</script>
<style lang="scss">
@import "src/style/common";
  #MonitorChildrenTable{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }

    .shopMain {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // margin-bottom: 5px;
      .content {
        width: calc(100% - 58px);
      }
      img {
        width: 84px;
        height: 84px;
        margin-right: 12px;
        display: block;
      }
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
  }
</style>
